module.exports = "/virtual-football-league/img/amblems/right/logos/Lazio.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Lazio.png
// module id = 2207
// module chunks = 4